export default __webpack_public_path__ + "static/media/upload.036e21e9.svg";